eyebrow: "Process"
headline: "From audit to autonomy<br/><em>— in five steps.</em>"

steps:
  - num: "01"
    title: "Discover the Operational Leaks"
    body: "We map your current processes end-to-end to identify bottlenecks, manual touchpoints, and inefficiencies costing your team time and money every week."
  - num: "02"
    title: "Architect the AI Layer"
    body: "Custom automation design built around your compliance requirements, data sensitivity, and team structure. No templates. No one-size-fits-all playbooks."
  - num: "03"
    title: "Build with Precision"
    body: "High-accuracy NLP, OCR, and reasoning systems engineered and tested against your actual documents and real-world edge cases — not synthetic benchmarks."
  - num: "04"
    title: "Deploy & Integrate"
    body: "Live deployment into your environment. All components synchronised. Data flows validated end-to-end. We handle the handoff properly."
  - num: "05"
    title: "Continuous Enablement"
    body: "We monitor, iterate, and evolve the system as your operational needs and AI capabilities grow — because autonomy is a direction, not a destination."
